import { useEffect } from "react"

export type Args<T> = {
  ref: React.MutableRefObject<HTMLElement | HTMLUListElement | HTMLDivElement>
  callback: (
    ref: React.MutableRefObject<HTMLElement | HTMLUListElement | HTMLDivElement>
  ) => void
  shouldFire: boolean
}

export const useHandleOutsideClick = <T,>({
  callback,
  ref,
  shouldFire
}: Args<T>) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      // handle the usecase where `shouldFire` is not being set as a boolean correctly
      const shouldFireCallback =
        typeof shouldFire === "boolean" ? shouldFire : true

      if (
        ref?.current &&
        !ref?.current?.contains(event.target) &&
        shouldFireCallback
      ) {
        callback(ref)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [ref, shouldFire])
}
